import React from "react";
import { useTranslation } from "react-i18next";
import Pagination from "react-js-pagination";
import DraftApplicationListItem from "./ListItem/DraftApplicationListItem";
const DraftApplicationList = (props) => {
  const { t } = useTranslation();

  const onPageChanged = (page) => {
    props.onPageChanged(page);
  };

  const getListingSummary = () => {
    const { listSummaryObject } = props;
    if (listSummaryObject.totalElements === 0) {
      return <h2 className="text-center">{t("DraftApplications.NoResultsFound")}</h2>;
    } else if (listSummaryObject.totalElements === 1) {
      return (
        <span>
          {" "}
          {listSummaryObject.totalElements} {t("DraftApplication.Found")} <br />
          <br />{" "}
        </span>
      );
    } else {
      return (
        <span>
          {" "}
          {listSummaryObject.totalElements} {t("DraftApplications.Found")} <br />
          <br />{" "}
        </span>
      );
    }
  };

  const { listSummaryObject } = props;
  if (!listSummaryObject) {
    return null;
  }
  console.log("listSummaryObject", listSummaryObject);
  return (
    <div className="clearfix dashboard-list dashboard-list--application-drafts">
      <div className="dashboard-list--header">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">{getListingSummary()}</div>
          </div>
        </div>
      </div>
      <div className="dashboard-list--inner">
        <div className="container">
          {listSummaryObject && listSummaryObject.content.length
            ? listSummaryObject.content.map((o, i) => <DraftApplicationListItem draft={o} key={i} />)
            : null}
        </div>
      </div>
      {listSummaryObject.totalPages > 1 ? (
        <div className="dashboard-list--footer">
          <div className="container">
            <div className="pager-wrapper clearfix">
              <Pagination
                activePage={listSummaryObject.number + 1}
                prevPageText="Prev"
                nextPageText="Next"
                itemsCountPerPage={listSummaryObject.size}
                totalItemsCount={listSummaryObject.totalElements}
                onChange={onPageChanged}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DraftApplicationList;
